import React, { useEffect, useState } from 'react'
import { useQuery } from '@apollo/react-hooks'
import Honeybadger from 'honeybadger-js'
import { asyncWithLDProvider, useLDClient } from 'launchdarkly-react-client-sdk'

import { UNPROTECTED_ROUTES } from 'constants/unprotectedRoutes'

import query from './currentUser.graphql'

export default function LDProvider({ children }) {
  const [LDProvider, setFlagsLoaded] = useState(null)
  const ldClient = useLDClient()
  const { data } = useQuery(query, {
    skip: UNPROTECTED_ROUTES.includes(window.location.pathname),
  })
  const currentUser = data && data.currentUser

  useEffect(() => {
    const fetchLDProvider = async () => {
      try {
        if (currentUser) {
          const {
            email,
            roles,
            district,
            institutions,
            primaryInstitution,
            email: key,
            fullName: name,
            launchdarklyState: state,
            isPaid: paid,
          } = currentUser

          const Provider = await asyncWithLDProvider({
            clientSideID: process.env.LAUNCHDARKLY_CLIENT_KEY,
            context: {
              kind: 'user',
              key,
              name,
              email,
              roles,
              state,
              paid,
              districts: district
                ? [`${district.title}_${district.id}`]
                : institutions.edges
                    .map(
                      institution =>
                        `${institution.node.district?.title}_${
                          institution.node.district?.id
                        }`
                    )
                    .filter(
                      (value, index, array) => array.indexOf(value) === index
                    ),
              institutions: roles.includes('district_admin')
                ? [`${primaryInstitution.title}_${primaryInstitution.id}`]
                : institutions.edges.map(
                    institution =>
                      `${institution.node.title}_${institution.node.id}`
                  ),
            },
            options: {
              streaming: false,
            },
          })

          setFlagsLoaded(() => Provider)
        }
      } catch (error) {
        Honeybadger.notify(error)
      }
    }

    fetchLDProvider()
  }, [currentUser, ldClient])

  if (LDProvider) {
    return <LDProvider>{children}</LDProvider>
  } else {
    return children
  }
}
